import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const DeleteDialog = ({ selectedItem, onClose, setPlans }) => {
  const handleConfirmDelete = (e) => {
    e.preventDefault();
    setPlans((prev) => prev.filter((plan) => plan.id !== selectedItem.id));
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Delete Item</DialogTitle>

      <DialogContent>
        Are you sure you want to delete <strong>{selectedItem?.name}</strong>?
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>

        <Button onClick={handleConfirmDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
